module.exports = __webpack_public_path__ + "media/application/images/ipad-48c70e05d862d69226904ab420ee661b.png";